import { FC } from 'react'
import { RenderFormikErrorsProps } from '../Forms.d'
import { Alert } from 'react-bootstrap'
import { buildFormikErrorsIbject } from './Helper'

const RenderFormikErrors: FC<RenderFormikErrorsProps> = ({ formikProps }) => {
    const errors = buildFormikErrorsIbject(formikProps)
    return (
        <>
            {Object.keys(errors).length > 0 ? (
                <Alert variant="danger">
                    {Object.keys(errors)?.map((key, index) => {
                        const error = errors[key]
                        return <div key={index}>{error.toString()}</div>
                    })}
                </Alert>
            ) : (
                <></>
            )}
        </>
    )
}

export default RenderFormikErrors
